module.exports = __webpack_public_path__ + "img/6.3062f0d4.jpg";